import { MEDIA } from '@/utils/CONST';
import { useGetList } from 'react-admin';
import { useMemo } from 'react';
import { composeMediaFmDownloadUrl } from '@/utils/compose';
import extractIdFromURI from '@/utils/id';

interface Media {
    id: string;
    contentUrlTokenAccess: string;
    '@type': string;
    urlToDownload: string;
    name: string;
}

interface Params {
    mediasIds: string[] | undefined;
}

interface Output {
    images: Media[] | undefined;
    audios: Media[] | undefined;
    documents: Media[] | undefined;
    isLoading: boolean;
    refetch: any;
}

const useGetMedias = ({ mediasIds }: Params): Output => {
    const { data, isLoading, refetch }: any = useGetList(
        MEDIA,
        {
            filter: {
                id: mediasIds,
            },
        },
        { enabled: mediasIds !== undefined && mediasIds.length > 0 },
    );

    const { images, audios, documents } = useMemo(() => {
        if (!data) {
            return {
                images: undefined,
                audios: undefined,
                documents: undefined,
            };
        }

        let images: Media[] = [];
        let audios: Media[] = [];
        let documents: Media[] = [];

        data.forEach((item: Media) => {
            const urlToDownload = composeMediaFmDownloadUrl(
                extractIdFromURI(item.id) ?? '',
                item.contentUrlTokenAccess,
            );

            const itemWithDownloadURl = {
                ...item,
                urlToDownload,
            };

            if (item['@type'] === 'Image') {
                images.push(itemWithDownloadURl);
            } else if (item['@type'] === 'Audio') {
                audios.push(itemWithDownloadURl);
            } else {
                documents.push(itemWithDownloadURl);
            }
        });

        return {
            images,
            audios,
            documents,
        };
    }, [data]);

    return {
        images,
        audios,
        documents,
        isLoading,
        refetch,
    };
};

export default useGetMedias;
